import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import AI1 from "./images/Ai1.png";
import AI3 from "./images/Ai3.png";
import AI_gif5 from "./images/frames.gif";
import AIg from "./images/Aig.gif";
import AI_4 from "./images/Ai6.png";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import R1 from "./images/R1.jpg";


export default function AiAccordion() {
    const n="n"
  return (
    <div className="Accordian">
        <Accordion className="Accordian" style={{ backgroundColor: "white" }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>
              <h3>Artificial Intelligence</h3>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <div
                id="ai-challenge"
                style={{ backgroundColor: "white", color: "black" }}
              >
                <div className="challenge-content">
                  <object align="left">
                    <h1 className="orange" style={{ color: "#f49221" }}>
                      Artificial{" "}
                      <span className="white">&nbsp;Intelligence</span>
                    </h1>
                    <p>
                      The challenges for AI recruitments have been hosted on
                      HackerRank. The challenges includes easy and hard
                      challenges.
                    </p>
                    <p ><strong>
                      The challenge is live on-{"  "}
                      <a
                        target="_blank"
                        href="https://www.hackerrank.com/project-manas-ai-recruitment-challenges-2025-26"
                        rel="noreferrer noopener"
                      >
                        HackerRank{" "}
                      </a>
                      </strong><br />
                      
                    </p>
                    <h2 className="">
                      <b>A Cloudy Day</b>
                    </h2>
                    <p>
                      Mrigaank and Vivek want to test our drone Freyjä for an upcoming competition. 
                      Unfortunately it begins to rain very heavily due to the sudden appearance of a large cloud. 
                      They realise that as the cloud moves, its size decreases due to the rain drops being released 
                      which occurs from its edges rather than its dense center. They further observe that the rate at 
                      which the rain drops release per second is equal to the magnitude of the cloud’s starting 
                      velocity. 
                    </p>
                    <p>
                      They want to estimate how long the rain will last but, both have to meet the director of 
                      academics later due to their poor attendance and thus, can't afford to get wet. So, they decide 
                      to put a tarp on our bot Steve with a multispectral camera attached in order to check the same. 
                      However the bot’s camera was not calibrated properly and captures the entire overhead sky. 
                      Furthermore, it experiences a slight distortion which affects the accuracy of the initial 
                      estimation such that certain points given by the camera do not exist. 
                    </p>
                    <p>
                      Assuming the cloud gains speed after releasing rain and that each droplet being released 
                      constitutes as a point within its structure, you must help determine how much space is 
                      available for testing the drone at a time ‘t’, so that Vivek and Mrigaank don’t miss their 
                      meeting and are allowed to write their end semester examinations. 
                    </p>
                    <center>(Note: No external force, such as air resistance, acts on the clouds and they move unidirectionally towards the right) </center>
                    <br />
                    <div className="center-image">
                      <div
                        className="hide-for-small-only"
                        style={{
                          width: "40%",
                          height: "50%",
                          display: "inline-block",
                        }}
                      >
                        <center>
                          <img className="gif1" src={AI1} alt="img" />
                          <br />
                          <br />
                        </center>
                      </div>
                    </div>
                    <br />

                    <h2 className="">
                      <b>Silent Strike</b>
                    </h2>

                    <p>
                      An approaching alien fleet takes the entire world by surprise. After months of failed attempts to
                      halt its advance, Commander Mrigaank authorizes a desperate final measure: the launch of a
                      powerful, untested muon ray gun, mounted on a missile and aimed directly at the enemy's
                      mothership.
                    </p>
                    <p>
                        The alien formation consists of multiple smaller spacecraft (represented by 1’s) and one
                        massive mothership (represented by 2’s), with empty space shown as 0’s. As the missile nears
                        its target, the aliens activate an EMP device, temporarily disabling Earth's satellites and cutting
                        off the missile’s navigation and communication systems, and making the propulsion system go
                        haywire. Fortunately, the muon ray gun remains functional, protected by shielding.
                    </p>
                    <p>
                        In a last-ditch defense, the mothership calls nearby smaller ships to converge around it.
                    </p>
                    <p>
                        Now Earth is left in the dark, unsure whether the strike succeeded. However, just before the
                        blackout, the missile managed to transmit a few final video frames showing alien ships directly
                        ahead.
                    </p>
                    <p>
                        Chief Engineer Vivek briefs you on the missile's weapon system:
                        <ul style={{marginLeft:"20px"}}>
                            <li> &#9679; The missile’s view that it sends is a rectangular grid (the video frame), and the current position of the missile is the middle row of this view.</li>
                            <li> &#9679; The muon ray gun can destroy everything along a vertical line (column) — from coordinate (0, h/2-2) to (0, h/2+2) (both inclusive). (i.e. in its view)</li>
                            <li> &#9679; It can only fire twice before it components wear out.</li>
                            <li> &#9679; It will fire if it senses any ships on its firing range(is checked every second)</li>
                            <li> &#9679; The frames are transmitted with a 1 second delay</li>
                        </ul>
                    </p>
                    <br />
                    <p>
                        Your mission: Using the transmitted frames, determine whether the missile will:
                        <ul style={{marginLeft:"20px"}}>
                            <li> &#9679; Hit any smaller ships</li>
                            <li> &#9679; Strike the mothership</li>
                            <li> &#9679; Miss all targets entirely</li>
                        </ul>
                        (Assume 0 angular velocity and 0 angular acceleration)
                    </p>

                    <br />
                    <h2 className="">
                      <b>The Glimmering Gate</b>
                    </h2>
                    <p>
                      In the hidden corners of Eldoria, a solitary threshold appears every hundred years. The
                       ancients call it the Glimmering Gate, a door that opens with knowledge. Be careful; many
                       doors look similar.
                    </p>
                    <p>
                       Traps throughout the glades resonate with magic: blessed, sealed, moonlit, runed, and
                       more. Only one has the true sound. The Spirit of the Grove, silent unless called upon,
                       may help you find out if an echo holds the right tone.
                    </p>
                    <p>
                       Your companion, a shimmering sprite, awakens at the rune-stone marked S. Its path is
                       narrow. The woods dim its light. A stride drains the spirit once. A turn takes twice as
                       much. Only the true Gate can restore what has been lost. Janak, with his hand
                       outstretched, whispered the first word of the journey. One path. One chance. The forest
                       was listening.
                    </p>
                    <div></div>
                    <br />
                    <br />
                    <div className="center-image">
                      <div
                        className="hide-for-small-only"
                        style={{
                          width: "40%",
                          height: "50%",
                          display: "inline-block",
                        }}
                      >
                        <center>
                          <img className="gif1" src={AI3} alt="img" />
                          <br />
                          <br />
                        </center>
                      </div>
                    </div>
                    <br />
                    <br />
                    <br />
                    <div>
                      <h2 className="">
                        <b>Toxic Fog</b>
                      </h2>

                      <p>
                        Deep beneath the MIT Library, a secret research lab run by Project MANAS was
                        experimenting with bio-chemicals to generate renewable energy. But due to an electrical
                        overload (caused by someone running GTA 6 on the lab PC), a containment breach
                        released toxic fog across campus. The fog is no longer a simple chemical cloud, it
                        moves faster and spreads unpredictably. Luckily, the campus was recently equipped
                        with autonomous evacuation bots. Your task is to simulate how the fog spreads and
                        rescue as many civilians as possible using the bots within a given time window.
                        </p>
                        <p>
                        You must model:
                        <ul style={{marginLeft:"20px"}}>
                            <li> &#9679; The fog spread</li>
                            <li> &#9679; Bot movement and civilian evacuation</li>
                            <li> &#9679; Building obstructions</li>
                            <li> &#9679; Survival within a limited time window</li>
                        </ul>
                      </p>
                      <br />
                    </div>
                    <div>
                      <h2 className="">
                        <b>Orbital Whispers</b>
                      </h2>

                      <p>
                        Lately, strange white shapes the scientists have started calling phantoms have been appearing
                        in a quiet field just outside town. They don’t travel in straight lines. Instead, they drift in slow,
                        looping arcs as if circling something no one can see.
                        Every few seconds, a drone captures a black and white image of the field. In these snapshots, 0
                        marks the ground and 1 marks the presence of something, usually a phantom. Frame by
                        frame, the same shapes shift slightly, always tracing a gentle orbit.
                        But not every white dot is a phantom. Some are just noise, tiny scattered bits that don’t follow
                        any clear path. You’ll need to tune those out.
                      </p>
                      <p>
                        The scientists are hoping you can help. Look through the frames, follow the phantoms, and find
                        the hidden centers they seem to be orbiting.
                      </p>
                    </div>
                    <div></div>
                    <br />
                    <br />
                    <div className="center-image">
                      <div
                        className="hide-for-small-only"
                        style={{
                          width: "50%",
                          height: "60%",
                          display: "inline-block",
                        }}
                      >
                        <center>
                          <img className="gif1" src={AI_gif5} alt="img" />
                          <br />
                          <br />
                        </center>
                      </div>
                    </div>
                    <br />
                    <div>
                      <h2 className="">
                        <b>Roadside Rescue</b>
                      </h2>

                      <p>
                        Following a sudden and unexpected fuel shortage, several members of Project MANAS, who were
                        out to purchase parts, have found themselves stranded across the city. Om would typically drive out
                        to rescue them, but he has a crucial interview to attend. It's now up to you to program the team's
                        autonomous bot, S.T.E.V.E, to deliver emergency fuel to all the stranded cars.
                      </p>
                      <p>
                        S.T.E.V.E starts at the team's garage at location (0,0) with a limited battery charge. It can only make
                        a certain number of movements before needing to return to the garage to recharge. Your task is to
                        program Steve to refuel as many stranded MANAS members as possible within this battery limit.
                      </p>
                      <p>
                        The representation for the city map is as follows:
                        <ul style={{marginLeft:"20px"}}>
                            <li>0: Represents a traversable space.</li>
                            <li>1: Represents an obstacle.</li>
                            <li>2: Represents a stranded car that needs refueling.</li>
                        </ul>
                      </p>
                      <p>
                        Each movement to an adjacent cell uses 1 battery charge. Refueling a car (at the cells represented
                        by 2) also uses 1 battery charge. The bot can only refuel a car once.
                      </p>
                      <p>
                        If there are multiple ways to refuel the maximum number of cars, prioritize the path that results in
                        the minimum total battery charge consumed (i.e., the path with the fewest movements.)
                      </p>
                      <p>
                        Your output should be the coordinates of all the cars that are refueled in the order they are visited,
                        followed by the complete path (sequence of coordinates) the bot takes from start, visiting the cars,
                        and returning to (0,0).
                      </p>
                    </div>
                    <div></div>
                    <br />
                    <br />
                    <div className="center-image">
                      <div
                        className="hide-for-small-only"
                        style={{
                          width: "30%",
                          height: "30%",
                          display: "inline-block",
                        }}
                      >
                        <center>
                          <img className="gif1" src={R1} alt="img" />
                          <br />
                          <br />
                        </center>
                      </div>
                    </div>
                    <br />
                    <div>
                      <h2 className="">
                        <b>Demolition Man</b>
                      </h2>

                      <p>
                        Today is the big day, Vivek Vercetti and his friend Mrigaank Vance have worked tirelessly for months
                        planning their attack on Asmit’s mansion. They have made a scouting drone Cleo along with their
                        modified ground vehicle Steve to go out and place bombs according to the map of the mansion Mrigaank
                        prepared in advance. Vivek was especially confident about the operation as he was sure that Cleo would
                        thoroughly search all the free space in the mansion.
                      </p>
                      <p>
                        Moving on with their plan to scout for enemies and then send Steve to carry out the bomb placement,
                        Vivek sets the clearance parameter of Cleo to 1 so that it always stays 1 unit away from any obstacles
                        (which are also the targets). As Vivek puts in the activation code in the Base Station, and the waypoints
                        for scouting the zone are calculated, Vivek hears a loud bang. Mrigaank blasted Steve to bits and ran
                        away. Vivek heard him calling Asmit on the radio. He tried to run away with all the dynamites but
                        their weight was too much for him to handle himself and some of them fell as he was trying to make his
                        escape.
                      </p>
                      <p>
                        Looking over at the computer, all the data about the mission was wiped which must be the work of
                        Mrigaank, Vivek thought. Thankfully, Vivek always had an inkling that Mrigaank was a double agent
                        and so he had made Cleo to be able to carry payload over short distances. The only data left was the
                        waypoints printed out on the console. Vivek thanked himself for writing all those print statements.
                      </p>
                      <p>
                        Now, while holding off the incoming goons, Vivek turns to you for help. You have to somehow use
                        this little info and limited resources to plan a route for Cleo to place the Dynamites on the centroids of
                        the targets while trying to destroy as much as possible. Due to Cleo being a scouting drone and having
                        to carry the heavy dynamites, it can’t travel very far so the route should be as short as possible.
                      </p>
                    </div>
                    <div></div>
                    <br />
                    <br />
                    <div className="center-image">
                      <div
                        className="hide-for-small-only"
                        style={{ width: "70%", height: "50%" }}
                      >
                        <center>
                          <img
                            className="embedded2-img"
                            src={AI_4}
                            alt="img"
                          />
                          {/*<figcaption align = "center"><i> Example Representation</i></figcaption>
                                            <br /> */}
                          <br />
                          <br />
                          <figcaption>
                            
                          </figcaption>
                          <br />
                        </center>
                      </div>
                    </div>
                    <br />
                    <div>
                      <h2 className="">
                        <b>Eyes in the Sky</b>
                      </h2>

                      <p>
                        During a drone surveillance mission over Manipal, Tanmay and Om detected mysterious graffiti
                        appearing on walls throughout the city. Each image captured by the drone is a 100×100 pixel
                        frame, represented as a 1D array of packed RGB values.
                      </p>
                      <p>
                        Through careful analysis, Asmit discovered that each image contains a 90×90 pixel poster,
                        identifiable by four subtly placed orange reference points embedded in the scene. The poster isn’t
                        always aligned perfectly,it can be tilted or skewed depending on the drone’s angle, requiring
                        precise geometric correction to view it head on.
                      </p>
                      <p>
                        Within this corrected poster lies a single 5×5 grid, marked by a distinct red dot at its center. This
                        grid isn’t just decorative,it encodes a three-letter hidden message using binary patterns.
                    </p>
                    <p>
                        Each image holds only one such encoded grid. Team Manas must locate the reference points,
                        realign the poster, detect the red-centered 5×5 block, and decode the binary pattern hidden within.
                        As the message spans multiple images, decoding and assembling all segments is the key to
                        revealing the full message,before the graffiti fades from Manipal’s walls forever.
                      </p>
                    </div>
                    <div></div>
                    <br />
                    <br />
                    <div className="center-image">
                      <div
                        className="hide-for-small-only"
                        style={{ width: "70%", height: "50%" }}
                      >
                        <center>
                          <img
                            className="embedded2-img"
                            src={AIg}
                            alt="img"
                          />
                          {/*<figcaption align = "center"><i> Example Representation</i></figcaption>
                                            <br /> */}
                          <br />
                          <br />
                          <figcaption>
                           
                          </figcaption>
                          <br />
                        </center>
                      </div>
                    </div>
                    <br />

                    <br />
                    <hr />
                    <br />
                    <h3>
                      <strong>Submission </strong>
                    </h3>
                    <p>
                      {" "}
                      The solutions will be accepted only through the
                      <a
                        href="https://www.hackerrank.com/project-manas-ai-recruitment-challenges-2025-26"
                        rel="noreferrer"
                        target="_blank"
                      >
                        {" "}
                        HackerRank
                      </a>{" "}
                      website.{" "}
                    </p>
                    <center>
                      <span>
                        {" "}
                        For any queries related to recruitments, feel free to
                        contact (Preferably via Whatsapp):{" "}
                      </span>
                    </center>
                    <div className="contact">
                      <br />
                      <p>
                        <b> Asavari </b>
                        <br /> +91 9999736682
                        <br />
                      </p>
                      <p>
                        <b> Chirag Rao </b>
                        <br /> +91 7028152399
                        <br />
                      </p>
                    </div>
                  </object>
                </div>
              </div>
            </Typography>
          </AccordionDetails>
        </Accordion>
    </div>
    );
}